export default __webpack_public_path__ + "static/media/ProductSans-Bold.0398942e.ttf";